module.exports = __webpack_public_path__ + "static/scale-model-of-columbia-view-park-in-gresham-oregon-d4618ad14db86a6f9071852454f5a802.png";